import React from "react";
import styled from "styled-components";

interface isForm {
  readonly isForm: boolean;
  readonly isEnding: boolean;
  readonly statePassed: boolean;
  readonly stateNoPass: boolean;
  readonly step3: boolean;
  readonly step4: boolean;
}

const Block = styled.div<isForm>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 1vh 3rem 1vh 3rem;
  margin-top: ${(props) =>
    props.isForm ? "1vh" : props.isEnding ? "10vh" : "3vh"};
  margin-bottom: ${(props) =>
    props.isForm ? "-1vh" : props.isEnding ? "5vh" : "0"};
  height: auto;

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: ${(props) =>
      props.isForm
        ? "min(max(18px, 2.8vw), 40px)"
        : props.isEnding
        ? "min(max(24px, 3.9vw), 50px)"
        : props.stateNoPass
        ? "min(max(26px, 3.5vw), 50px)"
        : "min(max(27px, 4vw), 55px)"};
    line-height: 110%;
    text-align: center;
    letter-spacing: -0.01em;
    color: #1d2f5d;
  }

  p {
    font-style: normal;
    font-weight: 600;
    font-size: ${(props) =>
      props.isForm
        ? "min(max(13px, 2.2vw), 28px)"
        : props.isEnding
        ? "min(max(18px, 2.5vw), 30px)"
        : props.stateNoPass
        ? "min(max(26px, 3.5vw), 50px)"
        : "min(max(27px, 4vw), 55px)"};
    line-height: ${(props) =>
      props.isForm ? "140%" : props.isEnding ? "140%" : "100%"};
    text-align: center;
    letter-spacing: -0.01em;
    width: ${(props) =>
      props.stateNoPass
        ? "100%"
        : props.isForm
        ? "100%"
        : props.isEnding
        ? "900px"
        : "700px"};
    margin-top: ${(props) =>
      props.isForm ? "1vh" : props.statePassed ? "1vh" : "3.5vh"};
  }

  @media (max-width: 1366px) {
    margin-top: ${(props) => props.isForm && "4vh"};

    h3 {
      font-size: ${(props) => props.isForm && "31.5px"};
    }

    p {
      font-size: ${(props) => props.isForm && "17.8px"};
      font-size: ${(props) => props.isEnding && "20px"};
      width: ${(props) =>
        props.isEnding
          ? "600px"
          : props.isForm
          ? "630px"
          : props.stateNoPass
          ? "68vw"
          : "700px"};
    }
  }

  @media (max-width: 768px) {
    margin: 10vh 2rem 1vh 2rem;
    margin-top: ${(props) =>
      props.isForm ? "3vh" : props.isEnding ? "10vh" : "6vh"};
    margin-bottom: ${(props) => (props.isForm ? "-1vh" : "0")};

    h3 {
      width: ${(props) =>
        props.stateNoPass
          ? "330px"
          : props.statePassed
          ? "205px"
          : props.step3
          ? "350px"
          : props.step4
          ? "292"
          : "275px"};
      font-size: ${(props) =>
        props.isForm ? "28px" : props.isEnding ? "24px" : "28px"};
    }

    p {
      font-size: ${(props) =>
        props.isForm ? "15px" : props.isEnding ? "18px" : "28px"};
      max-width: ${(props) =>
        props.isForm
          ? "360px"
          : props.isEnding
          ? "230px"
          : props.stateNoPass
          ? "320px"
          : "320px"};
      margin-top: ${(props) =>
        props.isForm ? "0.5vh" : props.statePassed ? "2vh" : "3.5vh"};
      margin-bottom: ${(props) => (props.isForm ? "-1vh" : "3.5vh")};
    }
  }

  @media (max-width: 456px) {
    h3 {
      font-size: ${(props) =>
        props.isForm ? "25px" : props.isEnding ? "24px" : "24px"};
      width: ${(props) =>
        props.stateNoPass
          ? "280px"
          : props.statePassed
          ? "180px"
          : props.step3
          ? "300px"
          : props.step4
          ? "300px"
          : "240px"};
    }
    p {
      font-size: ${(props) =>
        props.isForm
          ? "12.2px"
          : props.isEnding
          ? "16px"
          : props.stateNoPass
          ? "24px"
          : props.statePassed
          ? "24px"
          : "20px"};
      width: ${(props) =>
        props.isForm
          ? "300px"
          : props.isEnding
          ? "202px"
          : props.stateNoPass
          ? "290px"
          : props.statePassed
          ? "290px"
          : "230px"};
      margin-bottom: ${(props) => props.isEnding && "0rem"};
    }
  }

  @media (max-height: 500px) {
    margin-top: ${(props) =>
      props.isForm ? "4.5vh" : props.isEnding ? "10vh" : "6vh"};
    margin-bottom: ${(props) =>
      props.isForm
        ? "-1rem"
        : props.isEnding
        ? "3vh"
        : props.stateNoPass
        ? "5vh"
        : "0"};
  }

  @media (max-height: 500px) and (min-width: 1366px) {
    margin-bottom: ${(props) => props.isForm && "1rem"};
  }
`;

interface Props {
  question?: string;
  content?: string;
  step?: number;
  stateNoPass?: boolean;
}

const Question: React.FC<Props> = ({
  question,
  content,
  step,
  stateNoPass,
}) => {
  return (
    <Block
      isForm={step === 5 ? true : false}
      isEnding={step === 6 ? true : false}
      step3={step === 3 ? true : false}
      step4={step === 4 ? true : false}
      statePassed={!stateNoPass && step === 2}
      stateNoPass={stateNoPass && step === 2}
    >
      <h3>{question}</h3>
      {content && (
        <p
          style={{ color: step === 5 ? "#737373" : "#1d2f5d" }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </Block>
  );
};

export default Question;
